/**
 * AGM Exempted with Audited Financial Statements — 변수 ↔ 문서 매핑.
 */
export type AgmExemptedAfsDocKind =
  | 'directors_resolution'
  | 'members_resolution_multiple'
  | 'members_resolution_sole_corporate'
  | 'members_resolution_sole_individual';

export const ALL_DOC_KINDS: AgmExemptedAfsDocKind[] = [
  'directors_resolution',
  'members_resolution_multiple',
  'members_resolution_sole_corporate',
  'members_resolution_sole_individual',
];

export function classifyAgmExemptedAfsDoc(templateName: string): AgmExemptedAfsDocKind {
  const n = (templateName || '').toLowerCase();
  if (/members?['_\s]*resolutions?.*sole\s*individual/i.test(n)) {
    return 'members_resolution_sole_individual';
  }
  if (/members?['_\s]*resolutions?.*sole\s*corporate/i.test(n)) {
    return 'members_resolution_sole_corporate';
  }
  if (/members?['_\s]*resolutions?.*multiple/i.test(n)) {
    return 'members_resolution_multiple';
  }
  if (/directors?['_\s]*resolutions?/i.test(n)) {
    return 'directors_resolution';
  }
  return 'directors_resolution';
}

export const DOC_VARIABLES_BY_KIND: Record<AgmExemptedAfsDocKind, string[]> = {
  directors_resolution: [
    'company_name',
    'company_registration_no',
    'financial_year_end_date',
    'annual_return_year',
    'director_count',
    'specify_signers',
    'designated_signers',
    'signer_name',
    'has_retiring_directors',
    'retiring_directors',
    'director_name',
    'resolution_date',
  ],
  members_resolution_multiple: [
    'company_name',
    'company_registration_no',
    'deemed_agm_date',
    'financial_year_end_date',
    'has_directors_remuneration',
    'auditor_name',
    'has_retiring_directors',
    'retiring_directors',
    'director_name',
    'resolution_date',
  ],
  members_resolution_sole_corporate: [
    'company_name',
    'company_registration_no',
    'member_representative_name',
    'member_name',
    'deemed_agm_date',
    'financial_year_end_date',
    'has_directors_remuneration',
    'auditor_name',
    'has_retiring_directors',
    'retiring_directors',
    'director_name',
    'resolution_date',
  ],
  members_resolution_sole_individual: [
    'company_name',
    'company_registration_no',
    'member_name',
    'deemed_agm_date',
    'financial_year_end_date',
    'has_directors_remuneration',
    'auditor_name',
    'has_retiring_directors',
    'retiring_directors',
    'director_name',
    'resolution_date',
  ],
};

export const AGM_EXEMPTED_AFS_DOC_DISPLAY_ORDER: AgmExemptedAfsDocKind[] = [
  'directors_resolution',
  'members_resolution_multiple',
  'members_resolution_sole_corporate',
  'members_resolution_sole_individual',
];

export function sortAgmExemptedAfsDocsByDisplayOrder<T extends { kind: AgmExemptedAfsDocKind }>(
  docs: T[],
): T[] {
  return [...docs].sort(
    (a, b) =>
      AGM_EXEMPTED_AFS_DOC_DISPLAY_ORDER.indexOf(a.kind)
      - AGM_EXEMPTED_AFS_DOC_DISPLAY_ORDER.indexOf(b.kind),
  );
}
